import * as PriceDiscoveryActions from '../actions/PriceDiscoveryActions';
import {createFeatureSelector, createReducer, createSelector, on, props} from '@ngrx/store';
import {IPriceDiscoveryModel} from '../models/IPriceDiscoveryModel';

declare var moment: any;

const initialState = [];

export const reducer = createReducer(
  initialState,
  on(PriceDiscoveryActions.PriceDiscoveryReceived, (state, {prices}) => ([...prices]))
);

export const featureSelector = createFeatureSelector<Array<IPriceDiscoveryModel>>('priceDiscovery');
export const getPriceDiscovery = createSelector(
  featureSelector,
  state => state
);
